export function trim(str, maxLength, append = '..') {
    if (str.length > maxLength) {
        str = str.substr(0, maxLength).replace(/[^\w+]+$/, '') + append;
    }

    return str;
}